/* ESIMStore account helpers (27 Sep 2026). Used by My eSIMs and the product-page top-up picker. */
(function () {
  var ESI = (window.ESI = window.ESI || {});
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  var loading = null;
  ESI.loadMyEsims = function () {
    var cfg = window.ESI_ACCOUNT;
    if (!cfg) return Promise.resolve([]);
    if (!loading) {
      var url = cfg.api + '/my-esims?cid=' + encodeURIComponent(cfg.cid) + '&ts=' + encodeURIComponent(cfg.ts) + '&sig=' + encodeURIComponent(cfg.sig);
      loading = fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { return (d && d.esims) || []; })
        .catch(function (e) { loading = null; throw e; });
    }
    return loading;
  };

  ESI.fmtDate = function (iso) {
    if (!iso) return '';
    var d = new Date(iso.length === 10 ? iso + 'T00:00:00' : iso);
    if (isNaN(d)) return '';
    return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  };

  ESI.fmtData = function (mb) {
    if (mb == null || isNaN(mb)) return '';
    if (mb >= 1024) { var gb = mb / 1024; return (gb >= 10 ? Math.round(gb) : Math.round(gb * 10) / 10) + ' GB'; }
    return Math.round(mb) + ' MB';
  };

  // Label, tone and plain-English line for each state. Tones map to CSS pill colours.
  ESI.STATES = {
    active: { label: 'Active', tone: 'ok' },
    ready: { label: 'Ready to use', tone: 'info', text: 'Your plan starts when you first use data at your destination.' },
    not_installed: { label: 'Not installed', tone: 'warn', text: 'This eSIM is not on a phone yet. Install it before you travel.' },
    used_up: { label: 'Data used up', tone: 'bad', text: 'All the data on this plan is used. Add a plan to keep using this eSIM. You do not need a new eSIM.' },
    ended: { label: 'Plan ended', tone: 'muted', text: 'This eSIM has no plan now. It can stay on your phone. Add a plan when you travel again.' },
    preparing: { label: 'Being prepared', tone: 'info', text: 'We are preparing your eSIM. You will get an email with the QR code soon.' },
    unknown: { label: 'Status unavailable', tone: 'muted', text: 'We cannot get the status of this eSIM right now. Please try again later.' }
  };

  // Installed eSIMs that can take a top-up.
  ESI.canTopUp = function (e) { return ['active', 'ready', 'used_up', 'ended'].indexOf(e.state) !== -1; };

  var SEARCH_TERMS = { JPN: 'Japan', ITA: 'Italy', FRA: 'France', ESP: 'Spain', GBR: 'United Kingdom', UK: 'United Kingdom', USA: 'USA', THA: 'Thailand', VNM: 'Vietnam', IDN: 'Indonesia', KOR: 'Korea', CHN: 'China', AUS: 'Australia', NZL: 'New Zealand', SGP: 'Singapore', MYS: 'Malaysia', PHL: 'Philippines', IND: 'India', TUR: 'Turkey', GRC: 'Greece', EU28PLUS: 'Europe', EU: 'Europe', EUR: 'Europe', EUROPE: 'Europe' };
  ESI.topUpUrl = function (e) {
    var d = (e.destination || '').toUpperCase();
    var term = SEARCH_TERMS[d] || (/^EU/.test(d) ? 'Europe' : '') || (/^ASIA/.test(d) ? 'Asia' : '');
    return term ? '/search?type=product&q=' + encodeURIComponent(term) : '/collections/all';
  };
  // Remember which eSIM the customer wants to top up; the product page pre-selects it.
  ESI.startTopUp = function (e) {
    try { sessionStorage.setItem('esi_topup_target', e.topup_number || ''); } catch (err) {}
    window.location.href = ESI.topUpUrl(e);
  };
  ESI.topUpTarget = function () {
    try { return sessionStorage.getItem('esi_topup_target') || ''; } catch (err) { return ''; }
  };

  ESI.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
})();
